module.exports = __webpack_public_path__ + "img/floor_f2_01.fb46c858.png";